// extracted by mini-css-extract-plugin
export const root = "small-modules--root--1PgA_";
export const coverHover = "small-modules--coverHover--3oQWl";
export const coverContainer = "small-modules--coverContainer--1jbFD";
export const coverInner = "small-modules--coverInner--3dqY7";
export const coverPadding = "small-modules--coverPadding--3gKHw";